export enum TreasuryPage {
  Position = 'poz',
  Rotation = 'br',
  Profit = 'km',
  Loss = 'loss',
  LossTrans = 'loss_tran',
  Transprate = 'transprate',
}

export interface TreasuryServerData {}

export enum TreasuryServiceErrorCode {
  GENERAL,
}

export interface TreasuryFailure {
  message: string
}
